import {
  PlaneBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  Color,
  Matrix4,
  Plane,
  Vector3,
  AnimationClip,
  VectorKeyframeTrack,
  // sRGBEncoding,
  AnimationMixer
} from "three";

import { repeatTexture } from './functions';

class Terrain {

  constructor( name, width = 64, height = 64, color = 0xff0000, faces = 32 ) {

    color = new Color(color);
    color.convertSRGBToLinear();

    /* SETUP */
    const isFlat = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.flat :  false;
    const useBitmap = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.bitmap :  false;
    const useWireframe = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.wireframe :  false;
    const bitmapMaterial = ( window.ASSETS && useBitmap ) ? window.ASSETS.textures.find(obj => { return obj.name === name }).material : null;
    //bitmapMaterial.map.encoding = sRGBEncoding
    /* GEO */
    const geometry = new PlaneBufferGeometry(width, height, faces, faces);
    geometry.applyMatrix4( new Matrix4().makeRotationX(-Math.PI / 2) ); // start horizontal 

    /* GEO VERTICLES */

    if( !isFlat ){

      const positions = geometry.attributes.position;
      const rows = faces+1;
      const cols = rows; // if square
      const percentBack = 20;
      const percentSide = 44;
      const percentRow = rows / 100 * percentBack; // slope 20% of terrain
      const percentCol = cols / 100 * percentSide; // slope 20% of terrain
      const delta = width / faces; // 8
      const vertex = new Vector3();
      let row, col, slope;

      for(let i=0; i<positions.count; i++) {

        vertex.fromBufferAttribute( positions, i );
        row = Math.floor( i / rows );
        col = Math.floor( i % cols );

        if( row  < percentRow ){ // BACK
          slope = delta * 0.4
          // console.log( slope );
          vertex.y -= (percentRow*slope) - (row*slope);
        }else{ // FRONT
          slope = delta * 0.1;
          vertex.y -= (row-percentRow) * ( slope / ( (100 - percentBack)  / percentBack) );
        }

        slope = delta * 0.125;
        if( col  < percentCol ){ // LEFT
          vertex.y -= (percentCol*slope) - (col * slope );
        }else if( col > cols - percentCol){ // RIGHT
          vertex.y -=  (col - (cols - percentCol) ) * slope;
        }
        positions.setXYZ( i, vertex.x, vertex.y, vertex.z ); // NEW POS
      }
    }

    /* MATERIAL */

    const material = ( bitmapMaterial ) ? bitmapMaterial : new MeshBasicMaterial({color: color, wireframe:useWireframe }) ;
    if( useWireframe ) material.wireframe = useWireframe;

    /* MESH */

    const mesh = new Mesh(geometry,material);
    if( bitmapMaterial ) repeatTexture(mesh.material.map, faces/ (faces/4) );
    // mesh.position.y -= 80;
    mesh.matrixAutoUpdate = false;

    /* ANIMATE MATERIAL idea from https://discourse.threejs.org/t/material-animations-using-animationclips/3540 and https://jsfiddle.net/f2Lommf5/10232/ */
    
    if( bitmapMaterial ){
      var offset = new VectorKeyframeTrack( '.offset', [ 0, 1 ], [ 0, 0, 0, 1 ] );
      var clip = new AnimationClip( 'texture_animation', 1, [ offset ] );
      var mixer = new AnimationMixer( material.map );
      var clipAction = mixer.clipAction( clip );
      clipAction.play();
      
    }

    mesh.update = function( delta, amount = 100 ){
      if ( bitmapMaterial && mixer ) {
        mixer.update( delta * (amount*0.00775) ); // HACK: trying to match the movment of the brick road is hard coded and tweaked based on material repeat and image size
      }
    }

    /* FUNCTIONS */

    /* idea from https://discourse.threejs.org/t/custom-terrain-intersection-question/7178 */

    function getMapIndexFromPosition(x,y){
      x = Math.ceil((x / (width / faces)) + (faces / 2));
      y = Math.ceil((y / (height / faces)) + (faces / 2));
      x = Math.max(1,x);
      y = Math.max(1,y);
      return x + ( (y-1) * faces) - 1; // VERTICLES INDEX
    }
    
    const vector = new Vector3();

    function getIndexedVerticesFromMapIndex(idx){

      const vectors = [vector.clone(), vector.clone(), vector.clone()];

      if( mesh.geometry.index ){

        const indices = mesh.geometry.index.array;
        const vertices = mesh.geometry.attributes.position.array;
    
        let a,m;
    
        m = idx * 6;
        a = indices[m] * 3;
        vectors[0].set( vertices[a], vertices[a+1], vertices[a+2] );
        a = indices[m+1] * 3;
        vectors[1].set( vertices[a], vertices[a+1], vertices[a+2] );
        a = indices[m+2] * 3;
        vectors[2].set( vertices[a], vertices[a+1], vertices[a+2] );
    
      }
    
      return vectors;
    
    }

    const intersectPlane = new Plane();

    mesh.intersectTerrain = function(pos){
      const cpos = pos.clone();
      const idx = getMapIndexFromPosition(cpos.x,cpos.z);
      const intersectVectors = getIndexedVerticesFromMapIndex(idx);
      mesh.localToWorld( intersectVectors[0] );
      mesh.localToWorld( intersectVectors[1] );
      mesh.localToWorld( intersectVectors[2] );
      intersectPlane.setFromCoplanarPoints(intersectVectors[0], intersectVectors[1], intersectVectors[2]);
      let distance = intersectPlane.distanceToPoint( pos );
      distance = Math.round( distance*100 ) / 100;
      return distance;
    }

    return mesh;
  }
}

export { Terrain };